export const baseUrl = {
    "development":{
        "news":"http://10.106.0.197:8080/gildatahttpbiztrans/gildatasentiment/v1",
        "content":"http://10.106.0.197:8080/gildatahttpbiztrans/gildatabond/v1"
    },
    "test":{
        "news":"http://10.106.0.197:8080/gildatahttpbiztrans/gildatasentiment/v1",
        "content":"http://10.106.0.197:8080/gildatahttpbiztrans/gildatabond/v1"
    },
    "prelease":{
        "news":"https://zhimou.gildata.com/pre/gildatahttpbiztrans/gildatasentiment/v1",
        "content":"https://zhimou.gildata.com/pre/gildatahttpbiztrans/gildatabond/v1"
    },
    "production":{
        "news":"https://zhimou.gildata.com/gildatahttpbiztrans/gildatasentiment/v1",
        "content":"https://zhimou.gildata.com/gildatahttpbiztrans/gildatabond/v1"
    },
}